export default __webpack_public_path__ + "static/media/used-cubicles-teknion-2.0e1e9139.jpg";